<template>
  <svg id="asterix" viewBox="0 0 64 64">
    <path
      d="M36.1,4.5l7.4,14.7l16.5,2.4c3.7,0.5,5.2,5,2.5,7.6L50.5,40.7l2.8,16.2c0.6,3.7-3.2,6.5-6.6,4.7L32,54l-14.7,7.6
                c-3.3,1.7-7.2-1.1-6.6-4.7l2.8-16.2L1.6,29.2c-2.7-2.6-1.2-7.1,2.5-7.6l16.5-2.4l7.4-14.7C29.6,1.2,34.4,1.2,36.1,4.5"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconAsterix extends Vue {}
</script>
